import { computed } from 'vue'
import { useI18n } from '#i18n'

export const useMainMenuIrol = () => {
  const { t } = useI18n()

  const menuTop = computed(() => [
    {
      title: t('menu.MenuTop.backToUia'),
      items: [{ title: t('menu.MenuTop.home'), path: 'index' }]
    }
  ])

  const menuIrol = computed(() => [
    {
      title: t('menu.sectionUiaIrol.actions'),
      path: 'actions',
      icon: 'circle-chevron-up',
      iconCss: 'text-teal-500 bg-teal-500/20',
      linkCss: 'group-hover:text-teal-600 [&.router-link-exact-active]:text-teal-600',
      layout: 'irol'
    },
    {
      title: t('menu.sectionUiaIrol.presentation'),
      path: 'uia-irol',
      icon: 'gavel',
      iconCss: 'text-blue-500 bg-blue-500/20',
      linkCss: 'group-hover:text-blue-600 [&.router-link-exact-active]:text-blue-600',
      layout: 'irol'
    }
  ])
  return { menuTop, menuIrol }
}
